<template>
  <div
    @mouseover="setOpen(true, 'hover')"
    @mouseenter="setOpen(true, 'hover')"
    @mouseleave="setOpen(false, 'hover')"
  >
    <slot
      name="default"
      v-bind="{ setOpen, toggleOpen }"
    >
      <div
        id="collapse-button"
        class="collapse-menu-title"
        @click="toggleOpen()"
      >
        <span>{{ title }}</span>
        <img src="@/assets/icons/chevron-left.png" alt="chevron-down">
      </div>
    </slot>

    <!-- collapsible content -->
    <Transition name="slide">
      <div v-show="isOpen" class="content-wrapper" :style="customStyle">
      <slot name="content" v-bind="{ toggleOpen }">
          <div class="collapse-menu-options-wrapper">
            <a
              v-for="option in options"
              :id="option.id"
              :key="option.text"
              :href="option.url"
              :target="option.target"
              @click="updateClickEvent(option.event)"
              class="font-label-3 collapse-menu-options"
            >
              {{ option.text }}
            </a>
          </div>
        </slot>
    </div>
    </Transition>
  </div>
</template>

<script>
export default {
  name: 'CollapseMenu',
  props: {
    title: String,
    options: Array,
    refName: {
      type: String,
      default: 'collapse'
    },
    customStyle: {
      type: [Object, String],
      default: ''
    },
    toggleOnHover: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    updateClickEvent (eventName) {
      if (eventName) {
        this.$emit('click:log', eventName)
      }
    },
    setOpen (value, trigger = 'click') {
      if (trigger === 'hover' && !this.toggleOnHover) return
      if (value) this.collapseOthers()
      this.isOpen = value
    },
    toggleOpen () {
      this.setOpen(!this.isOpen)
    },
    collapseOthers () {
      const { $refs } = this.$parent.$parent
      for (const key in $refs) {
        const el = $refs[key]
        if (key.includes('collapse') && key !== this.refName && 'setOpen' in el) {
          el.setOpen(false)
        }
      }
      this.$emit('expand', this.refName)
    }
  },
  watch: {
    isOpen (value) {
      this.$emit('toggle')
      if (value) {
        this.$emit('show')
      } else {
        this.$emit('hide')
      }
    }
  }
}
</script>

<style scoped>
.right {
  right: 0;
}

.collapse-menu-title-wrapper {
  position: relative;
  padding: 5px;
}

.collapse-menu-title {
  cursor: pointer;
}

.content-wrapper {
  position: absolute;
  background-color: var(--color-neutral-100);
  border: 1px solid var(--color-ui-element-snow);
  border-radius: 10px;
  z-index: 3;
  box-shadow: 0px 8px 10px 1px #3333331A;
}

.collapse-menu-wrapper {
  position: absolute;
  background-color: var(--color-neutral-100);
  border: 1px solid var(--color-ui-element-snow);
  border-radius: 10px;
  z-index: 3;
  box-shadow: 0px 8px 10px 1px #3333331A;
}

.collapse-menu-options-wrapper {
  min-width: 200px;
  padding: 10px 0;
}

.collapse-menu-options {
  text-decoration: none;
  display: block;
  color: var(--color-text-primary);
  padding: 4px 16px;
}

.collapse-menu-options:hover {
  background-color: var(--color-neutral-300);
}

.slide-enter-active {
  max-height: 200px;
  -webkit-transition: max-height 0.35s ease;
  transition: max-height 0.35s ease;
}

.slide-leave-active {
  max-height: 200px;
  -webkit-transition: max-height 0.35s ease;
  transition: max-height 0.35s ease;
}

.slide-enter-from,
.slide-leave-to {
  max-height: 0;
  overflow: hidden;
}
</style>

